import { type IInsuranceCompanyPolicyHolders } from '@/app/types/dmsTypes'

import { Filters } from './Filters/Filters'
import style from './PolicyHolders.module.scss'

interface IProps extends IInsuranceCompanyPolicyHolders {
    filter: string
    setFilter: React.Dispatch<React.SetStateAction<string>>
    onGetPolicyHoldersHandler: (id: string, page: number, filterValue: string) => void
}

export const PolicyHolders = (props: IProps) => {
    const {
        filter,
        insuranceCompanyId,
        policyHolders,
        totalCount,
        pageSize,
        currentPage,
        setFilter,
        onGetPolicyHoldersHandler
    } = props
    const isFilters = !!filter || totalCount > pageSize
    return (
        <div className={style.container}>
            {isFilters && (
                <Filters
                    insuranceCompanyId={insuranceCompanyId}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    totalCount={totalCount}
                    filter={filter}
                    setFilter={setFilter}
                    onGetPolicyHoldersHandler={onGetPolicyHoldersHandler}
                />
            )}
            {policyHolders.map((holder) => {
                const { id, name, currentРoliciesCount } = holder
                return (
                    <div key={id} className={style.item}>
                        <span>{name}</span>
                        <span>Застрахованных: {currentРoliciesCount}</span>
                    </div>
                )
            })}
        </div>
    )
}
